import React from 'react'

import Page from '../../../../components/pdf/Page'
import Header from './sections/Header'
import ClientData from './sections/ClientData'
import Service from './sections/Service'
import Terms from './sections/Terms'
import Invoice from './sections/Invoice'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import {
  findReplyByQuestionId,
  findReplyByQuestionIds,
  getReplyValue,
  separateRepliesByInvoiceType
} from '../_helpers/pdfHelpers'
import { formatBlockReplies } from '../_helpers/formatBlocks'

const PdfDocument = () => {
  const serviceOrder = useServiceOrder()

  const replies = serviceOrder.replies

  const technicalScopeQuestions = [5889, 5891, 5895, 5887, 5893]
  const observationQuestions = [5890, 5892, 5896, 5888, 5894]

  const technicalScope = getReplyValue(findReplyByQuestionIds(replies, technicalScopeQuestions))
  const observation = getReplyValue(findReplyByQuestionIds(replies, observationQuestions))

  const formattedReplies = formatBlockReplies(replies)
  const blocksReplies = formattedReplies.filter(reply => reply.question.type.name === 'block')

  const nonBlockServiceQuestions = replies.filter(reply => [5718, 5720].includes(reply?.question?.id))

  const nonBlockServicesResult = nonBlockServiceQuestions.map(item => {
    const service = item?.value?.name
    const questionId = item?.questionId
    const firstQuestion = questionId === 5718
    const unitPriceQuestions = firstQuestion ? 5725 : 5727
    const totalAmountQuestions = firstQuestion ? 5726 : 5728
    const amountQuestions = firstQuestion ? 5719 : 5721
    const unitPrice = findReplyByQuestionId(replies, unitPriceQuestions)?.value
    const totalAmount = findReplyByQuestionId(replies, totalAmountQuestions)?.value
    const amount = findReplyByQuestionId(replies, amountQuestions)?.value
    return {
      amount,
      unitPrice,
      totalAmount,
      service
    }
  })

  const separatedReplies = separateRepliesByInvoiceType(blocksReplies)
  const data =
    blocksReplies.length === 0 ? { services: nonBlockServicesResult, equipments: [] } : { ...separatedReplies }

  return (
    <Page>
      <Header />
      <Service />
      <ClientData />
      <Invoice data={data} />
      <Terms technicalScope={technicalScope} observation={observation} />
    </Page>
  )
}

export default PdfDocument
